import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export const PricingSection = () => {
  const navigate = useNavigate();

  return (
    <section id="pricing" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center mb-12">Simple, Transparent Pricing</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="border rounded-lg p-6">
            <h3 className="text-xl font-bold mb-2">Free</h3>
            <div className="mt-2 flex justify-center">
              <img 
                src="/lovable-uploads/73bde646-0620-418e-9b4a-efbeed4f8aa3.png" 
                alt="Free Plan"
                className="h-44 w-44 object-contain"
              />
            </div>
            <p className="text-3xl font-bold mb-4">€0<span className="text-base font-normal">/month</span></p>
            <ul className="space-y-2 mb-6">
              <li>• 50 tokens per month</li>
              <li>• 1 email account</li>
              <li>• 3 AI assistants</li>
              <li>• Answer up to 3 emails at once</li>
            </ul>
            <Button className="w-full" variant="outline" onClick={() => navigate('/login')}>
              Get Started
            </Button>
          </div>
          <div className="border-2 border-primary rounded-lg p-6 relative">
            <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-primary text-white px-3 py-1 rounded-full text-sm">
              Most Popular
            </div>
            <h3 className="text-xl font-bold mb-2">Pro</h3>
            <div className="mt-2 flex justify-center">
              <img 
                src="/lovable-uploads/d8f8e50d-a9a4-430f-b58a-fcb704732604.png" 
                alt="Pro Plan"
                className="h-44 w-44 object-contain"
              />
            </div>
            <p className="text-3xl font-bold mb-4">€5<span className="text-base font-normal">/month</span></p>
            <ul className="space-y-2 mb-6">
              <li>• 200 tokens per month</li>
              <li>• 3 email accounts</li>
              <li>• 5 AI assistants</li>
              <li>• Answer up to 5 emails at once</li>
            </ul>
            <Button className="w-full" onClick={() => navigate('/login')}>
              Get Started
            </Button>
          </div>
          <div className="border rounded-lg p-6">
            <h3 className="text-xl font-bold mb-2">Premium</h3>
            <div className="mt-2 flex justify-center">
              <img 
                src="/lovable-uploads/1e482052-71bb-477d-a2e3-bdef83499b8d.png" 
                alt="Premium Plan"
                className="h-44 w-44 object-contain"
              />
            </div>
            <p className="text-3xl font-bold mb-4">€10<span className="text-base font-normal">/month</span></p>
            <ul className="space-y-2 mb-6">
              <li>• 500 tokens per month</li>
              <li>• Unlimited email accounts</li>
              <li>• Unlimited AI assistants</li>
              <li>• Answer unlimited emails at once</li>
            </ul>
            <Button className="w-full" variant="outline" onClick={() => navigate('/login')}>
              Get Started
            </Button>
          </div>
        </div>
        <p className="text-center text-gray-600 mt-8 text-lg">
          And don't worry if you run out of tokens, you can always make 1-time purchase of tokens at any time...
        </p>
      </div>
    </section>
  );
};